import styled from 'styled-components';

import { Flex } from '@/components/base';
import Typo, { Span, SpanStyle } from '@/components/Typography/Typo';
import useColor from '@/hooks/domain/useColor';
import textUtils from '@/utils/string';

import type { ExtendedFilterQueryFormatT } from './searchQueryBuilderTypes';

const SelectListWrapperStyle = styled(Flex)`
  width: 100%;
  overflow: auto;
  flex: 1;
`;

const FilterValueText = (props: {
  matchedValue: string;
  filterQueryFormat: ExtendedFilterQueryFormatT;
}) => {
  return (
    <Typo style={{ lineHeight: '18px' }}>
      {props.filterQueryFormat.filterValues[0]?.paths && (
        <Span type="label2">
          {props.filterQueryFormat.filterValues[0]?.paths?.join('/')} /&nbsp;
        </Span>
      )}
      <MatchedValueText
        matchedValue={props.matchedValue}
        text={props.filterQueryFormat.filterValues[0].filterName}
      />
      <Typo type="label3" weight="r" className="text-gray-600">
        &nbsp;&nbsp;&nbsp;
        {props.filterQueryFormat.domain
          ? `${props.filterQueryFormat.domain} : `
          : ''}
        {props.filterQueryFormat.columnName}
      </Typo>
    </Typo>
  );
};

const MatchedValueText = (props: {
  text: string;
  matchedValue: string;
  dim?: boolean;
}) => {
  const color = useColor();
  const matchedIndices = textUtils.getMatchedIndices(
    props.text,
    props.matchedValue,
  );

  if (!matchedIndices) {
    return (
      <Typo
        type={props.dim ? 'label3' : 'label2'}
        className={props.dim ? 'text-gray-600' : 'text-gray-800'}
      >
        {props.text}
      </Typo>
    );
  }

  const { startIndex, endIndex } = matchedIndices;
  const beforeMatch = props.text.slice(0, startIndex);
  const match = props.text.slice(startIndex, endIndex);
  const afterMatch = props.text.slice(endIndex);

  return (
    <Typo
      type={props.dim ? 'label3' : 'label2'}
      className={props.dim ? 'text-gray-600' : 'text-gray-800'}
    >
      {beforeMatch}
      <Typo
        type={props.dim ? 'label3' : 'label2'}
        style={{
          backgroundColor: color.primaryAlpha(0.1),
          borderRadius: 4,
          padding: '2px 0px',
        }}
        weight="sb"
      >
        {match}
      </Typo>
      {afterMatch}
    </Typo>
  );
};

const SectionTitleText = styled(Typo)`
  ${SpanStyle({
    type: 'label3',
    weight: 'sb',
  })}
  color: ${(props) => props.theme.colors.gray700};
  padding: 0px 12px;
`;

const SearchQueryBuilderStyles = {
  SelectListWrapperStyle,
  SectionTitleText,
  MatchedValueText,
  FilterValueText,
};

export default SearchQueryBuilderStyles;
